import { useContext } from 'react';
import { Form, Formik } from 'formik';
import { schemaMatchManual } from '../../schema/schemaMatchManual';
import { MatchContext } from '../../context/MatchContext';
import { AuthContext } from 'context';
import { PreviaMatchCampos } from './PreviaMatchCampos';

/**
 * @name PreviaMatchFormik
 * Formulaio de vista previa de match.
 */
export const PreviaMatchFormik = () => {
  const { isTienePermisos } = useContext(AuthContext);
  const { handleMatchManual, handleMatchSinNegocio } = useContext(MatchContext);
  const today = new Date();
  const todayPlusMonth = new Date(today.setMonth(today.getMonth() + 1));

  return (
    <Formik
      initialValues={{
        empresa: null,
        empresaSeleccionada: null,
        sucursal: null,
        sucursales: [],
        codigosTipoResiduo: '',
        codigosRecurso: '',
        fechaDisponibilidadInicio: new Date(),
        fechaDisponibilidadFin: todayPlusMonth,
        busquedaExtendida: false
      }}
      validateOnMount={false}
      validationSchema={schemaMatchManual(isTienePermisos)}
      validateOnChange={true}
      validateOnBlur={true}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          setSubmitting(true);
          await handleMatchManual(values);
          handleMatchSinNegocio(values);
        } catch (error) {
          console.log('error >>', error);
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        setFieldTouched,
        handleChange,
        isSubmitting
      }) => (
        <Form id="previaMatch">
          <div className="grid grid-cols-12 gap-5">
            <PreviaMatchCampos
              values={values}
              errors={errors}
              touched={touched}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              handleChange={handleChange}
              isSubmitting={isSubmitting}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};
